@if (hasHeader) {
    <header class="content-default__header">
        <div class="container--fluid px-16">
            <ng-content select="[header]" />
        </div>
    </header>
}

<main class="content-default__main">
    <div class="container p-24">
        <ng-content select="[content]" />
    </div>
</main>

@if (hasFooter) {
    <footer class="content-default__footer">
        <div class="container--fluid px-16 py-8">
            <ng-content select="[footer]" />
        </div>
    </footer>
}
